const state = {
    resultsMonthlyChart: [],
    resultsWeeklyChart: [],
    resultsAnnualChart: [],  
    resultsHappiness: [],
    loading: false,
};

export default state;